module.exports = __webpack_public_path__ + "static/media/banner_ilhagrande.21f563b9.jpg";